var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-2"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-lg-5 col-md-10 col-sm-12 text-right"},[_c('button',{staticClass:"btn btn-action btn-round btn-primary",on:{"click":_vm.viewReport}},[_vm._v("View")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }